/* ============================================================
   kunstli-inkybay-cart-labels.js
   InkyBay hardcoded cart text → Danish
   Cart page + cart drawer (re-runs on AJAX updates)
   ============================================================ */
(function () {
  'use strict';

  /* ── Text rules (edit here) ─────────────────────────────── */
  const RULES = [
    [/^\s*Color\s*:/,             'Variant :'          ],  // "Color : Skarpe hjørner"
    [/(\w+) file \(Attached\)/g,  '$1-fil (vedhæftet)' ],  // "SVG file (Attached)"
    [/^\s*-\s+/,                  ''                   ],  // " - Antal : 1"
    [/:\s*:/g,                    ':'                  ],  // "Valg Farve: : ..."
    [/^\s*Add Another Item\s*$/,  'Tilføj en mere'     ],  // duplicate button
  ];

  const DT_LABELS = {
    'Details:' : 'Detaljer: ',
  };

  /* ── Translate ──────────────────────────────────────────── */
  function translate(root) {
    root.querySelectorAll('.inkybay_cart_display').forEach(box => {
      const walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, {
        acceptNode: n => n.parentElement.closest('textarea')      // skip hidden XML
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT
      });
      let node;
      while ((node = walker.nextNode())) {
        let t = node.nodeValue;
        RULES.forEach(([re, rep]) => { t = t.replace(re, rep); });
        if (t !== node.nodeValue) node.nodeValue = t;
      }
    });

    root.querySelectorAll('dt strong').forEach(el => {
      const key = el.textContent.trim();
      if (DT_LABELS[key]) el.textContent = DT_LABELS[key];
    });
  }

  /* ── Run + watch for drawer / AJAX re-renders ───────────── */
  let queued = false;
  const run   = () => { queued = false; translate(document); };
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(run); } };

  run();
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
})();